import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

import PricePolicyStepDesktop from './PricePolicyStepDesktop';
import PricePolicyStepMobile from './PricePolicyStepMobile';

interface PricePolicyStepProps {
  pricePolicies: any[];
  selectedPricePolicyID: string;
  setSelectedPricePolicyID: (e: string) => void;
}

const PricePolicyStep = ({
  pricePolicies,
  selectedPricePolicyID,
  setSelectedPricePolicyID,
}: PricePolicyStepProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);
  const props = {
    pricePolicies,
    selectedPricePolicyID,
    setSelectedPricePolicyID,
  };
  const renderElements = {
    [DEVICES.DESKTOP]: <PricePolicyStepDesktop {...props} />,
    [DEVICES.MOBILE]: <PricePolicyStepMobile {...props} />,
    [DEVICES.TABLET]: <PricePolicyStepMobile {...props} />,
  };
  return renderElements[appDevice.device];
};

export default PricePolicyStep;
